module.exports = __webpack_public_path__ + "static/media/statusIcon.1e831594.svg";